import React from 'react'

import { useSelector } from 'react-redux'
import { selectAccountHash } from '@selectors'

import ActionButton from '@components/action-button/action-button.component'
import AlertFiles from '@components/alert-files/alert-files.component'
import BodyItem from '@components/body-item/body-item.component'
import CardDropdown from '@components/card-dropdown/card-dropdown.component'
import CardMap from '@components/card-map/card-map.component'
import CarouselContainer from '@components/carousel-container/carousel-container.component'
import ContactActionButton from '@components/contact-button/contact-button.component'
import UpdatedByContainer from '@components/updated-by-container/updated-by-container.component'


import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Carousel,
  GUN_GRAY,
  Title,
  WHITE
} from '@omnilert/components'


import {
  PRIORITY_BADGE_RESOLVED,
  PRIORITY_HEADER_TIP
} from '../../assets/i18n/strings'

import i18n from 'i18n-js'

import useStyles from './tip-priority.style'

const TipPriority = (props) => {
  const { message } = props
  
  const accountHash = useSelector(selectAccountHash)

  const { documentId } = message

  const tipRef = `tip-v1/${accountHash}/reference`

  const document = useSelector(({ firestore: { data } }) => data[tipRef] && data[tipRef][documentId])

  const {
    actions,
    body,
    contactActions,
    header,
    location,
    media,
    meta,
    updatedBy
  } = document

  const isResolved = meta?.isResolved

  const hasActions = !!actions?.data.length

  const hasMultipleActions = actions?.length > 1

  const variant = header?.data?.variant

  const titleColor = variant === 'invalid' ? GUN_GRAY : WHITE

  const classes = useStyles({ hasMultipleActions, variant })
  
  if (!document) return null

  return (
    <Card className={classes.card}>
      {header && (
        <CardHeader
          className={classes.cardHeader}
          type={variant}
        >
          <Title
            className={classes.title}
            color={titleColor}
            size='sm'
          >
            {i18n.t(PRIORITY_HEADER_TIP)}
          </Title>
          <CardDropdown
            data={header?.data}
            direction='bottom'
          />
        </CardHeader>
      )}

      {location && (
        <CardMap locations={location?.data} />
      )}

      {isResolved && (
        <Badge className={classes.badge}>
          {i18n.t(PRIORITY_BADGE_RESOLVED)}
        </Badge>
      )}

      {body && (
        <CardBody className={classes.cardBody}>
          {body.data.map((item, index) => (
            <BodyItem
              key={index}
              item={item}
            />
          ))}
        </CardBody>
      )}

      {media && <AlertFiles media={media} />}

      {updatedBy && <UpdatedByContainer
        data={updatedBy.data}
        showDivider
      />}

      {(contactActions || actions) && (
        <CarouselContainer>
          {contactActions ? (
            <Carousel className={classes.carousel}>
              {contactActions.data.map((data) => (
                <ContactActionButton
                  key={`contactAction-${data.id}`}
                  data={data}
                  documentId={documentId}
                />
              ))}
            </Carousel>
          ) : null}

          {hasActions ? (
            <Carousel
              className={classes.actionCarousel}
              hideActions={isResolved}
            >
              {actions.data.map((data) => (
                <ActionButton
                  key={`action-${data.id}`}
                  data={data}
                  documentId={documentId}
                />
              ))}
            </Carousel>
          ) : null}
        </CarouselContainer>
      )}
    </Card>
  )
}

export default TipPriority
